import { Text } from "@chakra-ui/react";

interface LegalPProps {
  children: React.ReactNode;
}

export default function LegalP({ children }: LegalPProps) {
  return (
    <Text
      fontFamily="body"
      fontWeight="300"
      fontSize="14px"
      lineHeight="1.8"
      color="text.primary"
      opacity={0.8}
      mb={3}
    >
      {children}
    </Text>
  );
}
